














import { Component, Vue } from 'vue-property-decorator';

import MasterStore from '@/store/MasterStore';
import AppStore from '@/store/App';

@Component({
  components: {
      TheDrawer: () => import('@/components/TheDrawer.vue'),
      TheFilter: () => import('@/components/core/Filter.vue'),
      TheToolbar: () => import('@/components/TheAppBar.vue'),
      TheView: () => import('@/components/TheView.vue'),
  },
})
export default class App extends Vue {
    get showView() {
        return this.$route.meta.public || MasterStore.loggedIn;
    }
}
